import { envPrefix } from '@story/constants';

export const setStorageItem = (key, value) => {
    localStorage.setItem(envPrefix + key, JSON.stringify(value));
};

export const getStorageItem = (key) => {
    try {
        const payload = JSON.parse(localStorage.getItem(envPrefix + key));
        if (Array.isArray(payload) && !payload.length) return {};
        return payload;
    } catch (error) {
        console.log('LOCALSTORE ERROR:', error, key);
    }

    return {};
};

export function setStorageItemWithExpiry(key, value, ttl) {
    const now = Date.now();
    const wrapper = {
        value,
        expiry: now + ttl,
    };
    localStorage.setItem(envPrefix + key, JSON.stringify(wrapper));
}

export function getStorageItemWithExpiry(key) {
    try {
        const itemStr = localStorage.getItem(envPrefix + key);
        if (!itemStr) return null;

        const item = JSON.parse(itemStr);
        if (item.expiry == null) {
            return item.value !== undefined ? item.value : item;
        }

        if (Date.now() > item.expiry) {
            localStorage.removeItem(envPrefix + key);
            return null;
        }

        return item.value;
    } catch (err) {
        console.warn('getStorageItemWithExpiry error for', key, err);
        localStorage.removeItem(envPrefix + key);
        return null;
    }
}

